import React, { useState } from 'react';
import PortletLayoutPreview from './PortletLayoutPreview';
import {
  PORTLET_LAYOUTS,
  PORTLET_ITEMS,
  getPortletItemLabelById,
} from '../../utils/managerUtils';

const PortletLayoutSelector = ({ selectedLayout, setSelectedLayout, zoneData, setZoneData }) => {
  const [dragSourceId, setDragSourceId] = useState(null);
  const [dragFromZone, setDragFromZone] = useState(null);
  const [dragOverKey, setDragOverKey] = useState('');

  const handleLayoutChange = layoutNum => {
    setSelectedLayout(layoutNum);
    setZoneData({});
  };

  const handleDropToZone = targetKey => {
    if (!dragSourceId) return;

    const sourceLabel = dragFromZone ? zoneData[dragFromZone]?.label : null;
    const label = getPortletItemLabelById(dragSourceId) || sourceLabel;
    if (!label) return;

    setZoneData(prev => {
      const next = { ...prev };

      if (dragFromZone && dragFromZone !== targetKey) {
        const targetData = next[targetKey] || null;
        if (targetData) next[dragFromZone] = targetData;
        else delete next[dragFromZone];
      } else if (!dragFromZone) {
        Object.keys(next).forEach(key => {
          if (next[key]?.id === dragSourceId) delete next[key];
        });
      }

      next[targetKey] = { id: dragSourceId, label };
      return next;
    });

    setDragSourceId(null);
    setDragFromZone(null);
    setDragOverKey('');
  };

  const usedIds = new Set(Object.values(zoneData).map(value => value?.id));

  return (
    <div className="manager-layout-selector">
      <div className="layout-top-section">
        <div className="layout-selector-cards">
          {Object.keys(PORTLET_LAYOUTS).map(layoutKey => {
            const layoutNum = Number(layoutKey);
            return (
              <label
                key={layoutNum}
                className={`layout-card ${selectedLayout === layoutNum ? 'selected' : ''}`}
              >
                <PortletLayoutPreview layoutNum={layoutNum} />
                <div className="layout-radio-wrap">
                  <input
                    type="radio"
                    name="P_PortletTypeNum"
                    value={layoutNum}
                    checked={selectedLayout === layoutNum}
                    onChange={() => handleLayoutChange(layoutNum)}
                  />
                </div>
              </label>
            );
          })}
        </div>
      </div>

      <div className="layout-bottom-section">
        <div className="layout-item-panel">
          <div className="layout-item-panel-title">항목</div>
          {PORTLET_ITEMS.map(item => (
            <div
              key={item.id}
              className={`layout-drag-item ${usedIds.has(item.id) ? 'used' : ''}`}
              draggable
              onDragStart={e => {
                setDragSourceId(item.id);
                setDragFromZone(null);
                e.dataTransfer.effectAllowed = 'move';
              }}
              onDragEnd={() => {
                setDragSourceId(null);
                setDragFromZone(null);
                setDragOverKey('');
              }}
            >
              {item.label}
            </div>
          ))}
        </div>

        <div className="layout-drop-panel">
          <div className="layout-drop-layout">
            {PORTLET_LAYOUTS[selectedLayout].rows.map((cols, rowIdx) => (
              <div className="layout-drop-row" key={`row-${rowIdx}`}>
                {Array.from({ length: cols }).map((_, colIdx) => {
                  const key = `${rowIdx}-${colIdx}`;
                  const placed = zoneData[key];
                  return (
                    <div
                      key={key}
                      className={`layout-drop-zone ${placed ? 'filled' : ''} ${dragOverKey === key ? 'drag-over' : ''}`}
                      onDragOver={e => {
                        e.preventDefault();
                        e.dataTransfer.dropEffect = 'move';
                      }}
                      onDragEnter={e => {
                        e.preventDefault();
                        setDragOverKey(key);
                      }}
                      onDragLeave={() => {
                        if (dragOverKey === key) setDragOverKey('');
                      }}
                      onDrop={e => {
                        e.preventDefault();
                        handleDropToZone(key);
                      }}
                      draggable={Boolean(placed)}
                      onDragStart={e => {
                        if (!placed) return;
                        setDragFromZone(key);
                        setDragSourceId(placed.id);
                        e.dataTransfer.effectAllowed = 'move';
                      }}
                      onDragEnd={() => {
                        setDragSourceId(null);
                        setDragFromZone(null);
                        setDragOverKey('');
                      }}
                    >
                      {placed ? (
                        <div className="layout-placed-item">
                          <span>{placed.label}</span>
                          <button
                            type="button"
                            className="layout-remove-btn"
                            onClick={() => {
                              setZoneData(prev => {
                                const next = { ...prev };
                                delete next[key];
                                return next;
                              });
                            }}
                          >
                            x
                          </button>
                        </div>
                      ) : (
                        <span className="layout-zone-hint">여기에 드래그</span>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortletLayoutSelector;
